/*
 * @Author: liuziwei
 * @Date: 2023-08-07 14:37:35
 * @LastEditTime: 2023-08-09 20:33:41
 * @LastEditors: liuziwei
 * @Description: 首页 - 天降弹窗 - 券列表
 * 睡觉了, 帮我关一下月亮 🌙  ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ
 */
<template minapp='mpx' xlang='wxml'>
  <!-- 领域展开 -->
  <view class="coupon-list-container" >
      <scroll-view scroll-y wx:if="{{listData.length>2}}" wx:style="height:{{listData.length*89}}px">
        <view wx:for="{{listData}}" wx:key="index" >
        <coupon-item couponData="{{item}}" couponTheme="{{couponTheme}}" />
      </view>
      </scroll-view>
      <view wx:else>
        <view wx:for="{{listData}}" wx:key="index" >
        <coupon-item couponData="{{item}}" couponTheme="{{couponTheme}}" />
      </view>
      </view>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'

  createComponent({
    props: {
      listData: {
        type: Array,
        value: () => []
      },
      couponTheme: {
        type: Object,
        value: () => {}
      }
    }
  })
</script>

<style lang='stylus' scoped>
  .coupon-list-container
    padding 0 12px
</style>

<script name='json'>
  module.exports = {
    usingComponents: {
      'coupon-item': './coupon-item'
    }
  }
</script>
